import { render } from "./number.vue?vue&type=template&id=bc3d46f6&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"

import "./number.vue?vue&type=style&index=0&id=bc3d46f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src16451840/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3d46f6"]])

export default __exports__